
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Mail, MessageSquare } from "lucide-react";
import { toast } from "sonner";

interface SocialRegisterProps {
  isLoading: boolean;
}

const SocialRegister = ({ isLoading }: SocialRegisterProps) => {
  const handleSocialRegister = async (provider: string) => {
    toast.info(`${provider} authentication is not implemented yet.`);
    // Will be implemented when social authentication is set up
  };

  return (
    <div className="mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <Separator className="w-full" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-white text-gray-500">
            Or continue with
          </span>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3">
        <Button
          type="button"
          variant="outline"
          onClick={() => handleSocialRegister("Google")}
          className="w-full flex items-center justify-center"
          disabled={isLoading}
        >
          <Mail className="h-5 w-5 mr-2" />
          <span>Google</span>
        </Button>

        <Button
          type="button"
          variant="outline"
          onClick={() => handleSocialRegister("Facebook")}
          className="w-full flex items-center justify-center"
          disabled={isLoading}
        >
          <MessageSquare className="h-5 w-5 mr-2" />
          <span>Facebook</span>
        </Button>
      </div>
    </div>
  );
};

export default SocialRegister;
